import { SubscriptionCredentials } from '../../domain/credentials/SubscriptionCredentials';
import { ProjectDrivers } from '../../domain/project/projectDrivers/ProjectDrivers';
import { ProjectDriversDTO } from '../../domain/project/projectDrivers/ProjectDriversDTO';
import {
  ProjectDriversInputField,
  ProjectDriversValueField,
} from '../../domain/project/projectDrivers/ProjectDriversEntityField';
import {
  ProjectDriversInputFieldRepository,
  ProjectDriversRepositoryDTO,
  ProjectDriversValueFieldRepository,
} from '../../domain/project/projectDrivers/ProjectDriversRepositoryDTO';

export class ProjectDriversMapper {
  static toDomain(props: ProjectDriversDTO): ProjectDrivers {
    const {
      configuration,
      stop_fields,
      task_fields,
      task_completed_fields,
      task_canceled_fields,
      stop_completed_fields,
      stop_canceled_fields,
    } = props;

    return ProjectDrivers.create({
      configuration,
      stop_fields,
      task_fields,
      task_completed_fields,
      task_canceled_fields,
      stop_completed_fields,
      stop_canceled_fields,
    });
  }

  static toRepository(
    projectDrivers: ProjectDrivers,
    subscriptionCredentials: SubscriptionCredentials
  ): ProjectDriversRepositoryDTO {
    const removeType = <T>(
      field: ProjectDriversValueField<T> | ProjectDriversInputField<T>
    ): ProjectDriversValueFieldRepository | ProjectDriversInputFieldRepository => {
      const { type, ...rest } = field;
      return rest;
    };

    const {
      configuration,
      stop_fields,
      task_fields,
      task_completed_fields,
      task_canceled_fields,
      stop_completed_fields,
      stop_canceled_fields,
    } = projectDrivers;

    return {
      stop_fields: stop_fields.map(removeType) as Array<ProjectDriversValueFieldRepository>,
      ...(subscriptionCredentials.test(`drivers.advanced_pod`)
        ? {
            configuration,
            task_fields: task_fields.map(removeType) as Array<ProjectDriversValueFieldRepository>,
            task_completed_fields: task_completed_fields.map(removeType) as Array<ProjectDriversInputFieldRepository>,
            task_canceled_fields: task_canceled_fields.map(removeType) as Array<ProjectDriversInputFieldRepository>,
            stop_completed_fields: stop_completed_fields.map(removeType) as Array<ProjectDriversInputFieldRepository>,
            stop_canceled_fields: stop_canceled_fields.map(removeType) as Array<ProjectDriversInputFieldRepository>,
          }
        : {}),
    };
  }

  static toDTO(projectDrivers: ProjectDrivers): ProjectDriversDTO {
    const {
      configuration,
      stop_fields,
      task_fields,
      task_completed_fields,
      task_canceled_fields,
      stop_completed_fields,
      stop_canceled_fields,
    } = projectDrivers;

    return {
      configuration,
      stop_fields,
      task_fields,
      task_completed_fields,
      task_canceled_fields,
      stop_completed_fields,
      stop_canceled_fields,
    };
  }
}
